// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-289f94fd] .ant-drawer-close {\n  width: 47px;\n  height: 47px;\n  line-height: 47px;\n}\n", ""]);
// Exports
module.exports = exports;
